import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './AvailRoomDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Image from '@synergycms_core/components/generic/Image';
import AmenitiesList from '../../AmenitiesList';
import { AvailBoardDetail } from '../AvailBoardDetail';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { AvailRoomDetailPreferences } from '../AvailRoomDetailPreferences';
import { AvailRoomDetailPreferencesToggle } from '../AvailRoomDetailPreferencesToggle';
import AvailRoomDetailModal from './AvailRoomDetailModal.jsx';
import ModalMedia from '../../ModalMedia/ModalMedia.jsx';
import { CSSTransition } from 'react-transition-group';
import { Map, List } from 'immutable';
import { SA_BOARD } from '../../../../config/constants';
import { cleanHotelPreferences, getRoomName, getUniqueRef } from '../../../../utils';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import ModalInfoStarTraveler from '../../Loyalty/StarTraveler/ModalInfoStarTraveler';
import { AvailContext } from './../availContext.jsx';
import { STAR_TRAVELER_CODE } from '@synergycms_app/store/customer/loyaltyActions';
import { isUsDomain, isUkDomain } from 'synergycms_core/src/utils/utils.js';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';

const RedRibbon = props =>
  Number.isFinite(props.quota) &&
  props.quota <= 5 && (
    <div className={props.classes.redRibbonContainer}>
      <div className={props.classes.redRibbon}>
        <RichText
          ucFirst={true}
          translate={true}
          quantity={props.quota}
          text={'_%solo queda%_'}
          innerStyle={['roboto11White']}
        />
        <RichText innerStyle={['roboto11White']} text={' ' + props.quota + '!'} />
      </div>
    </div>
  );

const RedRibbonFreeReservation = props =>
  <div className={props.classes.redRibbonContainer}>
    <div className={props.classes.redRibbon}>
      <RichText
        ucFirst={true}
        translate={true}
        text={'_%reserva sin tarjeta de crédito%_'}
        innerStyle={['roboto11White']}
      />
    </div>
  </div>;

const ShowMoreDetails = () => (
  <RichText
    text={'_%ver más detalles%_'}
    ucFirst={true}
    innerStyle={['roboto14Gold', 'roomCharacteristic']}
    translate={true}
  />
);

const AvailRoomDetail = class AvailRoomDetail extends React.Component {
  static displayName = 'AvailRoomDetail';
  static contextType = AvailContext;
  travelClubEnabled = false;
  constructor(props) {
    super(props);
    this.state = {
      editPreferences: false,
      width:null,
      galleryButtonId: null,
    };
    this.widthRef = React.createRef();
  }

  togglePreferences = e => {
    e.preventDefault();
    this.setState(state => ({
      editPreferences: !state.editPreferences
    }));
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth, this.widthRef.current.offsetHeight)
      });
    }
  }

  // GLOSARIO.md FCL-007
  updateGalleryButtonId = () => {
    const button = this.widthRef.current && this.widthRef.current.querySelector('button');
    if (!button) return;
    const positionImageClass = this.props.theme.styles.classes.positionImage;
    const galleryButtons = document.querySelectorAll('.' + positionImageClass + ' > button');
    const index = Array.prototype.indexOf.call(galleryButtons, button);
    const galleryButtonId = index === -1 ? null : 'td-gallery-monohotel-' + (80 + index);
    if (galleryButtonId !== this.state.galleryButtonId) {
      this.setState({ galleryButtonId });
    }
  }

  componentDidMount() {
    this.getWidthComponent();
    this.updateGalleryButtonId();
  }

  componentDidUpdate() {
    this.updateGalleryButtonId();
  }

  render() {
    const { config, theme, advantages, starTravelerTiers } = this.props,
      {
        roomAvail,
        staticRooms,
        selectRoomRate,
        roomId,
        segment,
        isFirstImage,
        changeRoomsPreferences,
        roomPreferences,
        adults,
        childs,
        babies,
        childsInfo,
        currentHotel,
        hotelPreferences,
        loyalty,
        langCode,
        ipCountry,
        travelClubImage,
        userTier,
        loyaltyType,
        hotelConfig
      } = config,
      serviceId = roomAvail.get('service_id'),
      occupGroupId = roomAvail.get('occup_group_id');
      this.travelClubEnabled = currentHotel.getIn(['travelclub'],false);
    const { loyaltyEnabled, existLoyaltyAvail } = this.context;
    const showStarTravelerRate = STAR_TRAVELER_CODE === loyaltyType && loyaltyEnabled && !!existLoyaltyAvail;

    const hidePromoCodeDesc = hotelConfig && hotelConfig.get('hide_promotionCode_description', false);

    const { classes } = theme.styles;
    const totalGuests = adults + (childs > 0 ? childs : 0);

    let resizableImages = theme.resizableImages && this.state.width ? this.state.width : '';
    // El nom de les habitacions s'ha d'agafar de les seccions d'habitació, no de l'habitació com a tal
    let roomSection =
      staticRooms.find(
        r =>
          r.get('id') === roomAvail.get('room_id') &&
          r.get('occup_group_id') === roomAvail.get('occup_group_id') &&
          r.get('service_id') === roomAvail.get('service_id')
      ) ||
      staticRooms.find(
        r =>
          r.get('id') === roomAvail.get('room_id') &&
          r.get('occup_group_id') === r.get('default_occup_group_id') &&
          r.get('service_id') === roomAvail.get('service_id')
      ) || Map();

    const needAddOccupName = (roomSection && roomSection.get('occup_group_id') !== roomAvail.get('occup_group_id')) || childsInfo;

    let roomOccupName =  getRoomName({childsInfo, childs, babies, adults });
    let roomName = roomSection && (!childsInfo || roomAvail.get('service_id'))? roomSection.get('name') : roomAvail.get?.('room_name');

    if (roomSection && roomAvail.get("service_description")) {
      roomSection = roomSection.set("description", roomAvail.get("service_description"));
    }
    if (roomSection && roomAvail.get("service_image")) {
      roomSection = roomSection.set("photo", roomAvail.get("service_image"));
      roomSection = roomSection.set("photos", roomSection.get("photos").unshift(roomAvail.get("service_image")));

    }

    roomSection = roomSection.set('video_url', roomSection.get('video_tour'));
    roomSection = roomSection.set('tour_360_url', roomSection.get('tour_360'));
    
    if (needAddOccupName) {
      roomName += roomOccupName;
    }


    const lastBoardId = roomAvail
      .get('boards')
      .keySeq()
      .last();

    let maxOccupRoom = staticRooms
      .maxBy(r => (r.get('id') === roomAvail.get('room_id') ? r.get('standard_occupancy') : 0))
      .get('standard_occupancy');

    if (maxOccupRoom < totalGuests) {
      maxOccupRoom = totalGuests;
    }

    const surfaceM2 = parseInt(roomSection.get('m2'), 10);
    // convertir de m2 a ft2 (para dominio .us/.co.uk)
    const surfaceFt2 = Math.round(surfaceM2 * 10.7639);

    const uniqueRef = roomAvail.getIn(['boards', '1', getUniqueRef(roomAvail.getIn(['boards', '1']))]);
    let fullFreeReservation = roomAvail.getIn(['boards', '1', uniqueRef, 'policies', 'penalties', 0]);
    if (fullFreeReservation) {
      fullFreeReservation = (fullFreeReservation.get('release', null) === 23976 && fullFreeReservation.get('type', null) === 'percentage'
        && fullFreeReservation.get('value', null) === 0 && fullFreeReservation.get('show_as', null) === 'days');
    }

    //ShowTravelClub
    const ipTravelClub = ['ES', 'PT', 'AD'].includes(ipCountry);

    // Mostrar boton publicidad -50% desayuno para usuario SILVER y GOLD
    const isBreakfastNotFree = !roomAvail.get('free_breakfast');
    const currentTier = userTier || false;
    const shouldShowBreakfastDiscount = isBreakfastNotFree && ['silver', 'gold'].includes(currentTier);
    const boardAvail = roomAvail.getIn(['boards']);
    let hasBreakfastDiscount = false;
    let hasPromoDescription = false;
    let hasDiscountDescription = false;

    boardAvail.forEach((board) => {
      const discounts = board.get(getUniqueRef(board), Map()).get('discounts', Map());

      if(!hasPromoDescription) {
        hasPromoDescription = board.valueSeq().map(rate => rate.get('promo_description')).find(desc => !!desc) || false;
      }
      if(!hasDiscountDescription) {
        hasDiscountDescription = discounts.map(dis => dis?.get('discount_description', false)).first() || false;
      }

      if (discounts.some(discount => discount.get('acronym') === '50_ST')) {
        hasBreakfastDiscount = true;
      }
    });
    
    hasPromoDescription = hidePromoCodeDesc ? false : hasPromoDescription;

    return (
      <div
        className={[
          theme.computedInnerStyle,
          Number.isFinite(roomAvail.get('quota')) && roomAvail.get('quota') > 5 && classes.noRibbon
        ].join(' ')}>
        {fullFreeReservation ? <RedRibbonFreeReservation classes={classes} /> :
          <RedRibbon classes={classes} quota={roomAvail.get('quota')} />}
        <div className={classes.header}>
          <div className={[classes.positionImage].join(' ')} ref={this.widthRef}>
            {/*<Image backgroundImage={roomSection.get('photo')} />*/}
            <Image
              innerStyle={'backgroundImageBase'}
              /*backgroundImage={
                process.env.NODE_ENV === 'development'
                  ? 'https://edge.media.datahc.com/HI378221428.jpg' + resizableImages
                  : roomSection.get('photo') + resizableImages
              }*/
              src={
                process.env.NODE_ENV === 'development'
                    ? 'https://edge.media.datahc.com/HI378221428.jpg' + resizableImages
                    : roomSection.get('photo') + resizableImages
              }
              // GLOSARIO.md FCL-005
              loading={isFirstImage ? 'eager' : 'lazy'}
              alt={roomName}
            />
            <ModalMedia mediaEntity={roomSection} langCode={langCode} innerStyle={classes.buttonImage} icon={{ unicodeContent:roomSection.get('photos')?.size > 1 ? 'e043' : null }} btnId={this.state.galleryButtonId} />
            {(roomSection.get('video_url') || roomSection.get('tour_360_url')) && (
              <div className={[
                classes.mediaExtraIcons,
                roomSection.get('photos')?.size > 1 ? '' : classes.mediaExtraIconsNoGallery
              ].join(' ')}>
                {roomSection.get('video_url') && (
                  <ModalMedia
                    mediaEntity={roomSection}
                    langCode={langCode}
                    initialTab={'video'}
                    innerStyle={classes.buttonImageVideo}
                    icon={{ unicodeContent: 'e14e' }}
                  />
                )}
                {roomSection.get('tour_360_url') && (
                  <ModalMedia
                    mediaEntity={roomSection}
                    langCode={langCode}
                    initialTab={'360'}
                    innerStyle={classes.buttonImage360}
                    icon={{ unicodeContent: 'e147' }}
                  />
                )}
              </div>
            )}
          </div>
          <div className={classes.heading} tabIndex={-1}>
            {hasPromoDescription && (
              <div className={classes.promoDescripction}>
                <Image
                  svg={'promotionalCode2'}
                  innerStyle={[classes.promoCodeIcon]}
                />
                <RichText
                  text={hasPromoDescription}
                  innerStyle={['mainColor', 'roboto14BoldBlack']}
                  translate={true}
                />
              </div>
            )}
            <div className={classes.logoRoomContainer}>
              <AvailRoomDetailModal
                roomInfo={roomSection}
                roomName={roomName}
                hotelInfo={currentHotel}
                travelClubEnabled={this.travelClubEnabled}
                buttonContent={() => <RichText
                  innerStyle={this.travelClubEnabled ? ['avail', 'roomTitle', 'travelClubTextWidth'] : ['avail', 'roomTitle']}
                  text={roomName}
                />}
              />
              <RichText innerStyle={classes.visibiltyHidden} ariaLabel={roomName} tabIndex={0}/>
              {this.travelClubEnabled ?
                <div className={ipTravelClub && travelClubImage === 'NOESP' ? classes.travelClubLogoWithOutPlane : classes.travelClubContainer}>
                  {(() => {
                    if (ipTravelClub && travelClubImage === 'NOESP') {
                      return (
                        <Image
                          svg={'travelClubLogoWithOutPlane'}
                          alt={roomName}
                        />
                      );
                    } else if (ipTravelClub && (travelClubImage === 'ESP' || travelClubImage === false )) {
                      return (
                        <div className={classes.travelClubContainer}>
                          <Image
                            svg={'travelClubLogo'}
                            alt={roomName}
                            innerStyle={classes.altLogoTravelClub}
                          />
                        </div>
                      );
                    }
                    return null;
                  })()}

                  {!this.isMobile() && ipTravelClub && (travelClubImage === 'ESP' || travelClubImage === false)  &&
                    <div className={classes.travelClubTextContainer}>
                      <RichText text={'_%acumula puntos%_'} innerStyle={['roboto14Gray']} ucFirst={true} translate={true} />
                      <span className={classes.travelClubText}>travel<RichText text={'_%club%_'} innerStyle={['roboto14Gray']} ucFirst={true} translate={true} /></span>
                    </div>
                  }
                </div>
              : '' }
            </div>
            {hasDiscountDescription && <span className={classes.discountDescripction}>{hasDiscountDescription}</span>}
            <span className={classes.roomDetails}>
              <RichText innerStyle={surfaceM2 > 0 ? ['roboto13Gray', 'roomSize', 'borderRightSoft'] : ['hideEdit']}>
                {isUsDomain() || isUkDomain() ? (
                  <>
                    {surfaceFt2}ft<sup>2</sup>
                  </>
                ) : (
                  <>
                    {surfaceM2}m<sup>2</sup>
                  </>
                )}
              </RichText>
              <div className={classes.maxOcupation}>
                <RichText text={'_%ocupación máx.%_'} innerStyle={['roboto14Gray']} ucFirst={true} translate={true} />
                <RichText text={': ' + maxOccupRoom} innerStyle={['roboto14Gray', 'maxOcup']} />
              </div>
              <div className={classes.maxOcupation}>
                <AvailRoomDetailModal
                  roomInfo={roomSection}
                  roomName={roomName}
                  hotelInfo={currentHotel}
                  buttonContent={ShowMoreDetails}
                />
              </div>
            </span>
            <div className={[classes.rowHotelContent, classes.amenitiesContainer].join(' ')}>
              <AmenitiesList
                maxAmenities={4}
                list={roomSection.get('highlighted_amenities', List())}
                innerStyle={['roomAmenities','noWhiteSpace', showStarTravelerRate ? 'roomDetailsPad' : '']}
              />
              {hotelPreferences && hotelPreferences.size > 0 && (
                <AvailRoomDetailPreferencesToggle
                  editPreferences={this.state.editPreferences}
                  togglePreferences={this.togglePreferences}
                />
              )}
            </div>
            {showStarTravelerRate ? (
                <div className={[classes.buttonStarTravel].join(' ')}>
                  <ModalInfoStarTraveler
                    id={'td-d1-startraveler-modal-01'}
                    advantages={advantages}
                    starTravelerTiers={starTravelerTiers}
                    buttonContent={() => {
                      if(shouldShowBreakfastDiscount && hasBreakfastDiscount) {
                        return (<RichText text={'_%boton_star_traveler_descuento_desayuno%_'} innerStyle={[classes.buttonStModal, classes.buttonSTbreakfast]} translate={true} />);
                      } else {
                        return  (<RichText text={'_%boton_star_traveler%_'} innerStyle={[classes.buttonStModal, 'capitalize']} translate={true} />);
                      };
                    }
                  }
                  />
                </div>
              ) : null}
          </div>
        </div>
        {roomPreferences && (
          <CSSTransition
            in={this.state.editPreferences}
            timeout={700}
            mountOnEnter
            unmountOnExit
            classNames={{
              enter: classes.roomPreferenceEnter,
              enterActive: classes.roomPreferenceEnterActive,
              exit: classes.roomPreferenceLeave,
              exitActive: classes.roomPreferenceLeaveActive
            }}>
            <AvailRoomDetailPreferences
              //innerStyle={this.state.editPreferences ? ['show'] : ['hide']}
              segment={segment}
              roomId={roomId}
              serviceId={serviceId}
              occupGroupId={occupGroupId}
              changeRoomsPreferences={changeRoomsPreferences}
              roomPreferences={roomPreferences[occupGroupId][serviceId || 0]}
            />
          </CSSTransition>
        )}
        <ul>
          {roomAvail
            .get('boards')
            .keySeq()
            .map(boardId => {
              const boardAvail = roomAvail.getIn(['boards', boardId]);
              const showBoard = !(
                roomAvail.get('free_breakfast') && SA_BOARD === boardAvail.getIn([getUniqueRef(boardAvail), 'board_code'])
              );

              return (
                showBoard && (
                  <li key={boardId} className={lastBoardId !== boardId ? [classes.withBorder] : []}>
                    <AvailBoardDetail
                      boardAvail={boardAvail}
                      boardId={boardId}
                      selectRoomRate={selectRoomRate}
                      roomId={roomId}
                      segment={segment}
                      serviceId={serviceId}
                      occupGroupId={occupGroupId}
                      adults={adults}
                      childs={childs}
                      babies={babies}
                      childsInfo={childsInfo}
                    />
                  </li>
                )
              );
            })}
            {currentHotel.get('loyalty') && loyalty && loyalty?.get("percentage") &&
              <li className={classes.loyalty}>
                  <span>*</span>
                  <RichText
                    translate={true}
                    text={'_%discount start fidelizacion%_'}
                  />
                  <RichText text={(loyalty.get("percentage") ?? "-")+'%'} innerStyle={['availDiscount']}/>
                  <RichText
                    translate={true}
                    dangerouslySetInnerHTML={true}
                    withVars={{LEVEL: loyalty?.get("level") ?? "-"}}
                    text={'_%discount end fidelizacion%_'}
                  />
              </li>
            }
        </ul>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const advantages = store.getIn(['customer', 'loyalty', 'data', 'advantages'], null);
  const starTravelerTiers = store.getIn(['customer', 'loyalty', 'data', 'tiers'], null);
  const userTier = store.getIn(['customer', 'loyalty', 'user', 'tier', 'current'], null);

  return {
    staticRooms: store.getIn(['hotels', hotelId, 'rooms']),
    currentHotel: store.getIn(['hotels', hotelId]),
    hotelPreferences: cleanHotelPreferences(store.getIn(['hotels', hotelId, 'preferences'], List())),
    loyalty : hotelId && store.getIn(['customer', 'loyalty','user', hotelId], null),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    ipCountry: store.getIn(['customer','country_ip'],false),
    travelClubImage: store.getIn(['hotels', hotelId, 'hotel_config', 'travelclub_image'], false),
    advantages: advantages,
    starTravelerTiers: starTravelerTiers,
    loyaltyType : store.getIn(["customer", "loyalty", "data", "loyalty", "code"],null),
    userTier: userTier,
    hotelConfig: contextualizeAppConfig(store, hotelId),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'roomAvail',
    'segment',
    'roomId',
    'isFirstImage',
    'staticRooms',
    'selectRoomRate',
    'changeRoomsPreferences',
    'roomPreferences',
    'adults',
    'childs',
    'babies',
    'childsInfo',
    'currentHotel',
    'hotelPreferences',
    'loyalty',
    'langCode',
    'ipCountry',
    'travelClubImage',
    'userTier',
    'loyaltyType',
    'hotelConfig'
  ]),
  withThemeJSS({ styleFile, link: true, index: 200 }),
  withContent('i18n')
)(AvailRoomDetail);
